import { useRouter } from "next/router";
import { useAtomValue, useSetAtom } from "jotai";
import { Typography } from "@mui/material";
import { isOrtexApp } from "@/lib/utils";
import { backgroundColorState, planPickerDrawerOpenState, userState } from "@/lib/store";
import useAppSubscriberUpgrade from "src/hooks/useAppSubscriberUpgrade";
import { UPGRADE_LOCATIONS, trackUpgradeClick } from "@/lib/tracking";
import styles from "./UpgradePlan.module.scss";

const UpgradePlan = () => {
    const user = useAtomValue(userState);
    const backgroundColor = useAtomValue(backgroundColorState);
    const setPlanPickerOpen = useSetAtom(planPickerDrawerOpenState);
    const { handleAppSubscriberUpgrade } = useAppSubscriberUpgrade();
    const { push } = useRouter();

    const isUserBasic = user?.subscription_plan === "ORTEX Basic";
    const isVisitor = !user?.subscription_plan || user.subscription_plan === "ORTEX Visitor";

    const onClick = () => {
        trackUpgradeClick(UPGRADE_LOCATIONS.CHART_UPGRADE_PLAN_BANNER, { plan: user?.subscription_plan });
        return isVisitor ? push("/login?register=true") : isOrtexApp() ? setPlanPickerOpen(true) : handleAppSubscriberUpgrade();
    };

    return (
        <div className={styles.UpgradePlan} style={{ backgroundColor }}>
            <Typography variant="body2">You are not seeing the latest updates on this chart as it&apos;s not included in your subscription.</Typography>
            {isVisitor ? (
                <Typography variant="body2">
                    <span onClick={onClick}>Create a free account</span> to get started with ORTEX.
                </Typography>
            ) : isUserBasic ? (
                <Typography variant="body2">
                    Please upgrade to <span onClick={onClick}>Advanced</span> to receive the latest data.
                </Typography>
            ) : (
                <Typography variant="body2">
                    Please <span onClick={onClick}>upgrade</span> your plan to receive the latest data.
                </Typography>
            )}
        </div>
    );
};

export default UpgradePlan;
